import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const PURCHASES = [{
  name: 'María G.',
  city: 'Córdoba'
}, {
  name: 'Juan P.',
  city: 'Buenos Aires'
}, {
  name: 'Laura M.',
  city: 'Rosario'
}, {
  name: 'Carlos D.',
  city: 'Mendoza'
}, {
  name: 'Silvia R.',
  city: 'Tucumán'
}, {
  name: 'Andrea F.',
  city: 'La Plata'
}, {
  name: 'Martín S.',
  city: 'Mar del Plata'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 8 and 15 seconds
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-start gap-3 max-w-sm animate-slide-up" data-id="element-7">
      <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-8">
        <X className="w-4 h-4" data-id="element-9" />
      </button>

      <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-10">
        <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-11" />
      </div>

      <div data-id="element-12">
        <p className="text-sm text-gray-800" data-id="element-13">
          <span className="font-bold" data-id="element-14">{currentPurchase.name}</span> de{' '}
          {currentPurchase.city}, Argentina
        </p>
        <p className="text-xs text-gray-500 mt-1" data-id="element-15">
          Compró MegaPack Matemática hace unos minutos
        </p>
      </div>
    </div>;
}